import React  from "react"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
import LazyLoad from "react-lazyload"
const AcheivementInSports = () => {
    const [index, setIndex] = React.useState(-1);
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/banner-sports.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page dark-th">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Achievements in Sports 2022-23" breadEnd="Learning Approach" breadMid="Achievements in Sports 2022-23" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4">
                            <div class="sportsAch">
                                <div class="text-box">
                                    <p>Sports are a crucial part of a learners’ overall development and help in the development of mental health and physical fitness of the body. Through participation in sports and games, learners gain various skills, experience and confidence that are helpful for developing their personality. Learners from our school participated in various sporting events and made us proud.</p>
                                    <h5>ATHLETICS</h5>
                                    <p><strong>NIDJAM National Inter District Junior Athletics Meet – 2023</strong></p>
                                    <p><strong>Venue:</strong> Patna, Bihar</p>
                                    <p><strong>Date:</strong> 9th – 12th February 2023</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view text-center">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> CATEGORY </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> MANIT BHASIN </td>
                                                    <td> VI Beas </td>
                                                    <td> Triathlon </td>
                                                    <td> Boys </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <p>Manit Bhasin of Grade VI Beas participated in a Triathlon event in NIDJAM National Inter District Junior Athletics Meet held at Patna, Bihar from 09th – 12th February 2023. His performance was very promising and outstanding during the athletics meet. </p>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/1.jpg" title="NIDJAM National Inter District Junior Athletics Meet – 2023">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/1.jpg" alt="CBSE National Science Exhibition 2022-23" onClick={() => setIndex(index)} /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/2.jpg" title="NIDJAM National Inter District Junior Athletics Meet – 2023">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/2.jpg" alt="CBSE National Science Exhibition 2022-23" onClick={() => setIndex(index)} /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>BASKETBALL</h5>
                                    <p><strong> Women Basketball National Camp</strong></p>
                                    <p><strong>Venue:</strong> Bhiwani, Haryana</p>
                                    <p><strong>Date:</strong> 29th – 30th August 2022</p>
                                    <p>Radha Hingne was the only learner from school level to get selected for this Open Age Category Championship. </p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Radha Hingne </td>
                                                    <td> X Whitney </td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/3.jpg" title="Women Basketball National Camp">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/3.jpg" alt="Women Basketball National Camp" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>Vijay Merchant Trophy Under-16 </strong></p>
                                    <p><strong>Venue</strong> : Cuttack (For League Matches)</p>
                                    <p><strong>Venue</strong>: Chennai (For Knock-out Matches)</p>
                                    <p><strong>Date</strong> : 1st December – 30th December</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aarav Gupta</td>
                                                    <td> X Andes </td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/4.jpg" title="Vijay Merchant Trophy Under-16">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/4.jpg" alt="Vijay Merchant Trophy Under-16" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p>Lotus Valley International School, Gurugram is proud to share that Aarav Gupta of Grade X-Andes represented Team Gurugram for U-16 Inter-District Cricket Tournament. He stood fourth in Haryana State in Medium Pacers Category, achieving nine wickets. Aarav was selected for U16 Haryana State Camp.</p>
                                    <p><strong>Khelo India Women’s Fencing League and Ranking Tournament – U17 &amp; U20</strong></p>
                                    <p><strong>Venue</strong>Talkatora Indoor stadium</p>
                                    <p><strong>Date : </strong>25th-29th July</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Kaina Malik</td>
                                                    <td> XI Shakespeare </td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/5.jpg" title="Khelo India Women’s Fencing League and Ranking Tournament – U17 &amp; U20">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/5.jpg" alt="Khelo India Women’s Fencing League and Ranking Tournament – U17 &amp; U20" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <p><strong>18th Figure and Speed National Skating Championship</strong></p>
                                    <p><strong>Venue</strong> : ISKATE by Roseate, Ambience Mall, Gurugram</p>
                                    <p><strong>Date : </strong>4th- 8th January 2023</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> POSITION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Agastya Singh Negi</td>
                                                    <td> I</td>
                                                    <td> Kingfishers</td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> AGE GROUP </th>
                                                    <th> EVENTS </th>
                                                    <th> POSITION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV</td>
                                                    <td> IX</td>
                                                    <td> KANCHENJUNGA</td>
                                                    <td> UNDER 15</td>
                                                    <td> 500 METERS </td>
                                                    <td> 1 <sup>st</sup> </td>
                                                </tr>

                                                <tr>
                                                    <td> 2 </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP</td>
                                                    <td> HIBISCUS </td>
                                                    <td> UNDER 11</td>
                                                    <td> FIGURE SKATING </td>
                                                    <td> 1 <sup>st</sup> </td>
                                                </tr>

                                                <tr>
                                                    <td> 3 </td>
                                                    <td> HRIDYA YADAV</td>
                                                    <td> IV</td>
                                                    <td> CHINARS </td>
                                                    <td> UNDER 11</td>
                                                    <td> 500 METERS </td>
                                                    <td> Participation</td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/6.jpg" title="18th Figure and Speed National Skating Championship">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/6.jpg" alt="18th Figure and Speed National Skating Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/7.jpg" title="18th Figure and Speed National Skating Championship">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/7.jpg" alt="18th Figure and Speed National Skating Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/8.jpg" title="18th Figure and Speed National Skating Championship">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/8.jpg" alt="18th Figure and Speed National Skating Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>36th National Games of India</strong></p>
                                    <p><strong>Venue: </strong>Gujarat</p>
                                    <p><strong>Date : </strong>29th September - 12th October 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Devashree Arora</td>
                                                    <td> VIII Danube</td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/9.jpg" title="36th National Games of India">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/9.jpg" alt="36th National Games of India" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>60th National RSFI Under-7 Skating Championship</strong></p>
                                    <p><strong>Venue</strong> : KRSA, Bangaluru</p>
                                    <p><strong>Date</strong> : 10th- 21st December 2022</p>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/10.jpg" title="60th National RSFI Under-7 Skating Championship">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/10.jpg" alt="60th National RSFI Under-7 Skating Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>CBSE North Zone II Speed Skating Championship 2022-2023</strong></p>
                                    <p><strong>Venue</strong>: South Point Public School, Sonipat</p>
                                    <p><strong>Date : </strong>29th November – 1st December 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> CATEGORY </th>
                                                    <th> EVENT </th>
                                                    <th> POSITION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td>KANCHENJUNGA </td>
                                                    <td>INLINE </td>
                                                    <td>300 meters Time Trial Rink Race </td>
                                                    <td>1 <sup>st</sup> </td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/11.jpg" title="CBSE North Zone II Speed Skating Championship 2022-2023">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/11.jpg" alt="CBSE North Zone II Speed Skating Championship 2022-2023" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/12.jpg" title="CBSE North Zone II Speed Skating Championship 2022-2023">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/12.jpg" alt="CBSE North Zone II Speed Skating Championship 2022-2023" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>





                                    <h5>SWIMMING</h5>
                                    <p><strong>CBSE NATIONAL SWIMMING CHAMPIONSHIP</strong></p>
                                    <p><strong>Venue:</strong> Genius English Medium School, Rajkot (Gujarat)</p>
                                    <p><strong>Date:</strong> 19th – 24th January 2023</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDALS </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 M Backstroke </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 M Freestyle </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 M Backstroke </td>
                                                    <td> Bronze </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <p><strong>48th Junior National Aquatic Championship</strong></p>
                                    <p><strong>Venue: </strong>Biju Patnaik Swimming Pool, Bhubaneshwar</p>
                                    <p><strong>Date</strong> : 16th-21st July 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                </tr>


                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/13.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/13.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/14.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/14.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/15.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/15.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/16.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/16.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p><strong>CBSE North Zone II Swimming Championship</strong></p>
                                    <p><strong>Venue</strong>: Govindgarh Mandi, Punjab</p>
                                    <p><strong>Date</strong> : 5th –  9th December 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDALS </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Freestyle </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Backstrokes </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Daisha Kaur </td>
                                                    <td> VI </td>
                                                    <td> Kaveri </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Bronze </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <h5>SHOOTING</h5>
                                    <p><strong>65th National Air Pistol Championship</strong></p>
                                    <p><strong>Venue: </strong>Bhopal (MP)</p>
                                    <p><strong>Date</strong>: 20th November - 12th December</p>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/17.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/17.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/18.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/18.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDALS </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Aairiya Jain </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> Shooting </td>
                                                    <td> Participation </td>
                                                </tr>
                                                <tr>

                                                </tr><tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/19.jpg" title="48th Junior National Aquatic Championship">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/19.jpg" alt="48th Junior National Aquatic Championship" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <h5>TAEKWON-DO</h5>
                                    <p><strong>37th National ITF Taekwondo Championship </strong></p>
                                    <p><strong>Venue</strong>: Thyagraj Stadium, New Delhi</p>
                                    <p><strong>Date</strong> : 4th November 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No </th>
                                                    <th> NAME </th>
                                                    <th> CATEGORY (KG) </th>
                                                    <th> GRADE </th>
                                                    <th> MEDAL </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Ishant Gupta </td>
                                                    <td> 40-45 KG </td>
                                                    <td> IX </td>
                                                    <td> Gold</td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Sidhansh Garg </td>
                                                    <td> 60-65 KG </td>
                                                    <td> VIII </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Rashesh Aggarwal </td>
                                                    <td> 60-65 KG </td>
                                                    <td> VIII </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> Advick Malik </td>
                                                    <td> 30-35 KG </td>
                                                    <td> VII </td>
                                                    <td> Bronze </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/20.jpg" title="37th National ITF Taekwondo Championship">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/20.jpg" alt="37th National ITF Taekwondo Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>ATHLETICS</h5>
                                    <p><strong>SGFI Inter-School Athletic Meet </strong></p>
                                    <p><strong>Venue</strong>: Tau Devi Lal Stadium, Gurugram</p>
                                    <p><strong>Date</strong> : 22nd November 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> CATEGORY </th>
                                                    <th> MEDAL </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aman Verma </td>
                                                    <td> V Cedars </td>
                                                    <td> 200 M </td>
                                                    <td> Boys </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Ananya Singh </td>
                                                    <td> V Oaks </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Girls </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Vaanya Sharma </td>
                                                    <td> V Oaks </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Girls </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Kiara Jai Prakash </td>
                                                    <td> V Oaks </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Girls </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> Mihira Das </td>
                                                    <td> V Neems </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Girls </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> Aman Verma </td>
                                                    <td> V Cedars </td>
                                                    <td> 100 M </td>
                                                    <td> Boys </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> Aman Verma </td>
                                                    <td> V Cedars </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Boys </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 8 </td>
                                                    <td> Vishist Bajpai </td>
                                                    <td> V Oaks </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Boys </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 9 </td>
                                                    <td> Siddhant jain </td>
                                                    <td> V Neems </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Boys </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 10 </td>
                                                    <td> Lakshya Bhansali </td>
                                                    <td> V Neems </td>
                                                    <td> 4x100 M Relay </td>
                                                    <td> Boys </td>
                                                    <td> Bronze </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/21.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/21.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/22.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/22.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p><strong>SGFI Inter-School Athletic Meet </strong></p>
                                    <p><strong>Venue</strong>: Tau Devi Lal Stadium, Gurugram</p>
                                    <p><strong>Date</strong> : 22nd November 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> CATEGORY </th>
                                                    <th> MEDAL </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Manit Bhasin </td>
                                                    <td> VI Beas </td>
                                                    <td> Triathlon </td>
                                                    <td> Boys </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Gianaa Malik </td>
                                                    <td> VIII Colorado </td>
                                                    <td> Triathlon </td>
                                                    <td> Girls </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Gianaa Malik </td>
                                                    <td> VIII Colorado </td>
                                                    <td> Javelin </td>
                                                    <td> Girls </td>
                                                    <td> Bronze </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/23.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/23.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/24.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/24.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>BADMINTON</h5>
                                    <p><strong>DPSG Sushant Lok Inter School Badminton Tournament</strong></p>
                                    <p><strong>Venue</strong>: DPSG Sushant Lok, Gurugram</p>
                                    <p><strong>Date</strong> : 31st January 2023 </p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> POSITION/MEDAL </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">
                                                <tr><td>	1	</td><td>	Devaansh Wadhwa	</td><td>	VII	</td><td>	Mahanadi	</td><td>	1st/Gold	</td></tr>


                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/25.jpg" title="DPSG Sushant Lok Inter School Badminton Tournament">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/25.jpg" alt="DPSG Sushant Lok Inter School Badminton Tournament" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/26.jpg" title="DPSG Sushant Lok Inter School Badminton Tournament">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/26.jpg" alt="DPSG Sushant Lok Inter School Badminton Tournament" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>


                                    <h5>BASKETBALL</h5>
                                    <p><strong>Haryana State Women Basketball Championship </strong></p>
                                    <p><strong>Venue:</strong> Rohtak (Kiloi)</p>
                                    <p><strong>Date:</strong> 27th-29th August 2022</p>
                                    <p>Radha Hingne was the only learner from school level to get selected for this Open Age Category Championship. </p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th>S.NO.</th>
                                                    <th>NAME</th>
                                                    <th>CLASS/SECTION</th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td>1</td>
                                                    <td>Radha Hingne</td>
                                                    <td>X Whitney</td>
                                                </tr>
                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/7.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/7.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong> SGFI District Basketball Championship – U14</strong></p>
                                    <p><strong>Venue:</strong> Tau Devi Lal Stadium, Gurugram</p>
                                    <p><strong>Date:</strong> 10th September 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> TOURNAMENT </th>
                                                    <th> DATE &amp; VENUE </th>
                                                    <th> POSITION </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aadya Proothi </td>
                                                    <td> VII Ravi </td>
                                                    <td> SGFI District Basketball Championship – U14 </td>
                                                    <td> 10th September Tau Devi Lal Stadium </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Lakshya Singhal </td>
                                                    <td> VIII Volga </td>
                                                    <td> SGFI District Basketball Championship – U14 </td>
                                                    <td> 10th September Tau Devi Lal Stadium </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Radha Hingne </td>
                                                    <td> X Whitney </td>
                                                    <td> SGFI District Basketball Championship – U17 </td>
                                                    <td> 10th September Tau Devi Lal Stadium </td>
                                                    <td> Gold </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/8.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/8.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/9.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/9.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/10.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/10.jpg" alt="CBSE National Science Exhibition 2022-23" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <h5>HARYANA STATE BASKETBALL TOURNAMENTS</h5>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> TOURNAMENT </th>
                                                    <th> DATE &amp; VENUE </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Radha Hingne </td>
                                                    <td> X Whitney </td>
                                                    <td> Haryana State Junior Basketball Championship – U19 </td>
                                                    <td> 17th-18th September Bhiwani </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Radha Hingne </td>
                                                    <td> X Whitney </td>
                                                    <td> Haryana Youth State Basketball Championship – U16 </td>
                                                    <td> 22nd-24th November Charkhi Dadri </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Lakshay Singhal </td>
                                                    <td> VIII Volga </td>
                                                    <td> Haryana Sub-Junior State Basketball Championship – U14 </td>
                                                    <td> 29th-31st October Sonipath (Mohana) </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Lakshay Singhal </td>
                                                    <td> VIII Volga </td>
                                                    <td> SGFI State Basketball Championship – U14 </td>
                                                    <td> 17th-18th November Hisar </td>
                                                </tr>


                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> TOURNAMENT </th>
                                                    <th> DATE &amp; VENUE </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aadya Proothi </td>
                                                    <td> VII Ravi </td>
                                                    <td> SGFI State Basketball Championship – U14 </td>
                                                    <td> 4th-6th December Fatehabad </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Radha Hingne </td>
                                                    <td> X Whitney </td>
                                                    <td> SGFI State Basketball Championship – U16 </td>
                                                    <td> 4th-6th December Fatehabad </td>
                                                </tr>

                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <h5>Haryana SGFI Basketball Championship – U14 (Boys)</h5>
                                    <p><strong>Venue: </strong>Tau Devi Lal Stadium, Gurugram</p>
                                    <p><strong>Date:</strong> 5th-10th September</p>
                                    <p><strong>Lotus Valley International School, Gorugram team bagged the 3rd position in this Championship</strong></p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Manit Bhasin </td>
                                                    <td> VI Beas </td>
                                                    <td> Beas </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Neel Dubey </td>
                                                    <td> VII Ravi </td>
                                                    <td> Ravi </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Advik Malik </td>
                                                    <td> VII Indus </td>
                                                    <td> Indus </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Lakshay Singhal </td>
                                                    <td> VIII Volga </td>
                                                    <td> Volga </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> Aryaman Shukla </td>
                                                    <td> VIII Nile </td>
                                                    <td> Nile </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> Kyaan Prakash </td>
                                                    <td> VIII Mississippi </td>
                                                    <td> Mississippi </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> Prakhar Bhukal </td>
                                                    <td> VIII Mississippi </td>
                                                    <td> Mississippi </td>
                                                </tr>


                                                <tr>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp10.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp10.jpg" alt="Lotus Valley International School, Gorugram team bagged the 3rd position in this Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>CRICKET</h5>
                                    <p><strong>Under 16 Inter District Tournament </strong></p>
                                    <p>Lotus Valley International School, Gurugram is proud to share that Aarav Gupta of Grade X-Andes represented Team Gurugram for U-16 Inter-District Cricket Tournament.
                                        He stood fourth in Haryana State in Medium Pacers Category, achieving nine wickets.</p>
                                    <p>Aarav has been selected for U16 Haryana State Camp, which will be held this year.</p>


                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aarav Gupta </td>
                                                    <td> X Andes </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp11.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp11.jpg" alt="Lotus Valley International School, Gorugram team bagged the 3rd position in this Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>Vijay Merchant Trophy Under-16 </strong></p>
                                    <p><strong>Venue: </strong>Cuttack (For League Matches)</p>
                                    <p><strong>Venue: </strong>Chennai (For Knock-out Matches)</p>
                                    <p><strong>Date : </strong>1st December – 30th December</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Aarav Gupta </td>
                                                    <td> X Andes </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/sp27.jpg" title="Vijay Merchant Trophy Under-16">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/sp27.jpg" alt="Vijay Merchant Trophy Under-16" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>FENCING</h5>
                                    <p><strong>10th Junior Delhi State Fencing Championship</strong></p>
                                    <p><strong>Venue: </strong>G R International School, Pooth Khurd, New</p>
                                    <p><strong>Date : </strong>5th June 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Kaina Malik </td>
                                                    <td> XI Shakespeare </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <p><strong>Khelo India Women’s Fencing League and Ranking Tournament – U17 &amp; U20</strong></p>

                                    <p><strong>Venue: </strong>Talkatora Indoor stadium</p>
                                    <p><strong>Date : </strong>25th-29th July</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Kaina Malik </td>
                                                    <td> XI Shakespeare </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp13.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp13.jpg" alt="9Th Cadet U-18 Delhi State Fencing Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>9Th Cadet U-18 Delhi State Fencing Championship</strong></p>
                                    <p><strong>Venue: </strong>Venkateshwar Global School, Sector-13 Rohini</p>
                                    <p><strong>Date : </strong>26th-4th December</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> Position / Medal </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Kaina Malik </td>
                                                    <td> XI Shakespeare </td>
                                                    <td> Gold </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/sp28.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/achievement2324/sp28.jpg" alt="9Th Cadet U-18 Delhi State Fencing Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>Football</h5>
                                    <p><strong>SGFI Inter-School Block Level Tournament – U17</strong></p>
                                    <p><strong>Venue: </strong>GSSS Garhi Harsaru</p>
                                    <p><strong>Date : </strong>6th-9th September 2022</p>
                                    <p>Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship.</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">


                                                <tr>
                                                    <td> 1 </td>
                                                    <td> ISHAAN DAS </td>
                                                    <td> VIII </td>
                                                    <td> AMAZON </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> JAY SINGH </td>
                                                    <td> IX </td>
                                                    <td> SHIVALIK </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> ISHANT GUPTA </td>
                                                    <td> IX </td>
                                                    <td> KAMET </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> ADITYA THAKUR </td>
                                                    <td> IX </td>
                                                    <td> VINDHYAS </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> VATSAL </td>
                                                    <td> IX </td>
                                                    <td> KAMET </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> SAGAR AGGARWAL </td>
                                                    <td> X </td>
                                                    <td> ELBERT </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> KABIR </td>
                                                    <td> X </td>
                                                    <td> ELBERT </td>
                                                </tr>
                                                <tr>
                                                    <td> 8 </td>
                                                    <td> MOKSH PAWAR </td>
                                                    <td> X </td>
                                                    <td> ELBERT </td>
                                                </tr>
                                                <tr>
                                                    <td> 9 </td>
                                                    <td> AYAAN BHOLA </td>
                                                    <td> X </td>
                                                    <td> OLYMPUS </td>
                                                </tr>
                                                <tr>
                                                    <td> 10 </td>
                                                    <td> RONAN VIKRAM SINGH </td>
                                                    <td> X </td>
                                                    <td> FUJI </td>
                                                </tr>
                                                <tr>
                                                    <td> 11 </td>
                                                    <td> KRISHIV SOBHANI </td>
                                                    <td> X </td>
                                                    <td> OLYMPUS </td>
                                                </tr>
                                                <tr>
                                                    <td> 12 </td>
                                                    <td> ABHIMANYU </td>
                                                    <td> X </td>
                                                    <td> EHITNEY </td>
                                                </tr>
                                                <tr>
                                                    <td> 13 </td>
                                                    <td> ABEER RARA </td>
                                                    <td> X </td>
                                                    <td> WHITNEY </td>
                                                </tr>
                                                <tr>
                                                    <td> 14 </td>
                                                    <td> SIDDHANT CHONKAR </td>
                                                    <td> XI </td>
                                                    <td> KEYNES </td>
                                                </tr>
                                                <tr>
                                                    <td> 15 </td>
                                                    <td> UDAY PAWAR </td>
                                                    <td> XII </td>
                                                    <td> MARSHALL </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp15.jpg">

                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp15.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <p><strong>Vibgyor-Viva 5-a-Side Football Inter-School Championship – U12</strong></p>
                                    <p><strong>Venue: </strong>Vibgyor High School, Sector 67</p>
                                    <p><strong>Date :</strong> 2nd November 2022</p>
                                    <p><strong>Team’s Position: </strong>2nd Runner Up</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Arjun Guha </td>
                                                    <td> VI </td>
                                                    <td> Kaveri </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Amber Vashishth </td>
                                                    <td> VI </td>
                                                    <td> Narmada </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Divij Arora </td>
                                                    <td> VI </td>
                                                    <td> Narmada </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Aarav Jain </td>
                                                    <td> VI </td>
                                                    <td> Godavari </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> Annan </td>
                                                    <td> VI </td>
                                                    <td> Narmada </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> Siddhant Jain </td>
                                                    <td> V </td>
                                                    <td> Neems </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> Pranay Bhatia </td>
                                                    <td> V </td>
                                                    <td> Birches </td>
                                                </tr>
                                                <tr>
                                                    <td> 8 </td>
                                                    <td> Arnav Jain </td>
                                                    <td> V </td>
                                                    <td> Oaks </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp16.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp16.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>Vibgyor-Viva 5-a-Side Football Inter-School Championship – U10</strong></p>
                                    <p><strong>Venue: </strong>Vibgyor High School, Sector 67</p>
                                    <p><strong>Date : </strong>2nd November 2002</p>
                                    <p><strong>Team’s Position:</strong> 2nd Runner Up</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Sarthak Pandey </td>
                                                    <td> IV </td>
                                                    <td> Aspens </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Sparsh Mittal </td>
                                                    <td> IV </td>
                                                    <td> Aspens </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Adhiraaj Singh Rathor </td>
                                                    <td> IV </td>
                                                    <td> Banyans </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Aditya Raj Mayor </td>
                                                    <td> IV </td>
                                                    <td> Acacias </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> Adhrit Chakraborty </td>
                                                    <td> IV </td>
                                                    <td> Gulmohars </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> Avyaan Mathur </td>
                                                    <td> IV </td>
                                                    <td> Chinars </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> Vihaan Mehta </td>
                                                    <td> III </td>
                                                    <td> Skylarks </td>
                                                </tr>
                                                <tr>
                                                    <td> 8 </td>
                                                    <td> Manit Jain </td>
                                                    <td> III </td>
                                                    <td> Skylarks </td>
                                                </tr>
                                                <tr>
                                                    <td> 9 </td>
                                                    <td> Rudra Raj Chandra </td>
                                                    <td> III </td>
                                                    <td> Peacocks </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp17.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp17.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>ICE SKATING</h5>
                                    <p><strong>6th HARAYNA STATE ICE SKATING CHAMPIONSHIP </strong></p>
                                    <p><strong>Venue: </strong>ISKATE by Roseate, Ambience Mall, Gurugram</p>
                                    <p><strong>Date :</strong> 7th-8th November 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> AGE GROUP </th>
                                                    <th> EVENT </th>
                                                    <th> Position </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 15 </td>
                                                    <td> 500 METERS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> HRIDYA YADAV </td>
                                                    <td> IV </td>
                                                    <td> CHINARS </td>
                                                    <td> UNDER 10 </td>
                                                    <td> 500 METERS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP </td>
                                                    <td> HIBISCUS </td>
                                                    <td> UNDER 7 </td>
                                                    <td> FIGURE SKATING </td>
                                                    <td> 1st </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp18.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp18.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp19.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp19.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp20.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp20.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                    <p><strong>DISTRICT ICE SKATING CHAMPIONSHIP </strong></p>
                                    <p><strong>Venue: </strong>ISKATE by Roseate, Ambience Mall, Gurugram</p>
                                    <p><strong>Date : </strong>31st October – 2nd November </p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> AGE GROUP </th>
                                                    <th> EVENT </th>
                                                    <th> Position </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 15 </td>
                                                    <td> 500 METERS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> HRIDYA YADAV </td>
                                                    <td> IV </td>
                                                    <td> CHINARS </td>
                                                    <td> UNDER 10 </td>
                                                    <td> 500 METERS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP </td>
                                                    <td> HIBISCUS </td>
                                                    <td> UNDER 7 </td>
                                                    <td> FIGURE SKATING </td>
                                                    <td> 1st </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp21.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp21.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp22.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp22.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp23.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp23.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>18th Figure and Speed National Skating Championship</strong></p>
                                    <p><strong>Venue: </strong>ISKATE by Roseate, Ambience Mall, Gurugram</p>
                                    <p><strong>Date : </strong>4th - 8th January 2023</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> AGE GROUP </th>
                                                    <th> EVENT </th>
                                                    <th> Position </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 15 </td>
                                                    <td> 500 METERS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP </td>
                                                    <td> HIBISCUS </td>
                                                    <td> UNDER 11 </td>
                                                    <td> FIGURE SKATING </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> HRIDYA YADAV </td>
                                                    <td> IV </td>
                                                    <td> CHINARS </td>
                                                    <td> UNDER 11 </td>
                                                    <td> 500 METERS </td>
                                                    <td> Participation </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp24.jpg">

                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp24.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp25.jpg">

                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp25.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp26.jpg">

                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp26.jpg" alt="Lotus Valley International School, Gurugram bagged the 2nd position in this tournament. Two players, Ayaan Bhola and Krishiv Sobhani got selected for the District Football Championship." /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>LAWN TENNIS </h5>

                                    <p><strong>GD Goenka Sports Fiesta (Inter-School Championship)</strong></p>
                                    <p><strong>Venue: </strong>G D Goenka Public School, Sector 48, Gurugram</p>
                                    <p><strong>Date : </strong>25th – 26th November 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Shaurya Sharma </td>
                                                    <td> X </td>
                                                    <td> Elbert </td>
                                                    <td> Lawn Tennis </td>
                                                    <td> Gold </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp27.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp27.jpg" alt="Lotus Valley International School, Gorugram team bagged the 3rd position in this Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>SQUASH</h5>
                                    <p><strong>Haryana State Squash Racket Championship</strong></p>
                                    <p><strong>Venue:</strong> Maharishi Markandeshwar University, Mullana, Ambala</p>
                                    <p><strong>Date : </strong>11th &amp; 12th June 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                    <th> POSITION </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Devashree Arora </td>
                                                    <td> VIII Danube </td>
                                                    <td> Gold </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp28.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp28.jpg" alt="Lotus Valley International School, Gorugram team bagged the 3rd position in this Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>36th National Games of India</strong></p>
                                    <p><strong>Venue: </strong>Gujarat</p>
                                    <p><strong>Date : </strong>29th September - 12th October 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CLASS/SECTION </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Devashree Arora </td>
                                                    <td> VIII Danube </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp29.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp29.jpg" alt="36th National Games of India" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>SKATING</h5>
                                    <p><strong>Under 17 SGFI Block Speed Skating Competition</strong></p>
                                    <p><strong>Venue: </strong>YLSC, Club Baliawas</p>
                                    <p><strong>Date : </strong>1st-3rd September 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> EVENT  </th>
                                                    <th> AGE GROUP </th>
                                                    <th> CATEGORY </th>
                                                    <th> Position </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX  </td>
                                                    <td> 500 + D Rink Race  </td>
                                                    <td> U -17  </td>
                                                    <td> INLINE   </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> 3000 meters Road Race  </td>
                                                    <td> U -17 </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp30.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp30.jpg" alt="Under 17 SGFI Block Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>Under 17 and 19 SGFI District Speed Skating</strong></p>
                                    <p><strong>Venue: </strong>YLSC, Club Baliawas</p>
                                    <p><strong>Date : </strong>8th-10th September 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> EVENT </th>
                                                    <th> AGE GROUP </th>
                                                    <th> CATEGORY </th>
                                                    <th> Position </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> 500 + D Rink Race </td>
                                                    <td> U -17 </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> 3000 meters Road Race </td>
                                                    <td> U -17 </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp31.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp31.jpg" alt="Lotus Valley International School, Gorugram team bagged the 3rd position in this Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>Roller Hockey Championship</strong></p>
                                    <p><strong>Venue: </strong>YLSC, Club Baliawas</p>
                                    <p><strong>Date : </strong>8th-10th September 2022</p>
                                    <p>Lotus Valley International School, Gurugram participated in Roller Hockey Championship in Under 19 Age Group held at YLSC CLUB, Baliawas on 10th September 2022 and secured 2nd Position. The team has qualified for the State Championship that will be held in the month of October.
                                    </p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No </th>
                                                    <th> NAME </th>
                                                    <th> GARDE </th>
                                                    <th> AGE GROUP </th>
                                                </tr>



                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> VIDHAAN TRIPATHI </td>
                                                    <td> ANDES </td>
                                                    <td> UNDER 19 </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> KESHAV PARSAD </td>
                                                    <td> FUJI </td>
                                                    <td> UNDER 19 </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> JAI ADITYA </td>
                                                    <td> CONGO </td>
                                                    <td> UNDER 19 </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AKSHAT GUPTA </td>
                                                    <td> CONGO </td>
                                                    <td> UNDER 19 </td>
                                                </tr>



                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp32.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp32.jpg" alt="Roller Hockey Championship" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <p><strong>15th RSFI District Speed Skating Competition</strong></p>
                                    <p><strong>Venue: </strong>Club Baliawas</p>
                                    <p><strong>Date : </strong>17th-19th October 2022</p>
                                    <p><strong> All three learners have been selected for the RSFI Haryana State Championship that will held from 2nd to 4th November 2022 at Panchkula (Chandigarh). </strong></p>


                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> AGE GROUP </th>
                                                    <th> EVENT </th>
                                                    <th> Position </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 17 </td>
                                                    <td> 500+D RINK </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 17 </td>
                                                    <td> 1000 RINK </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 17 </td>
                                                    <td> 1 LAP ROAD </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> AGASTYA NEGI </td>
                                                    <td> I </td>
                                                    <td> KINGFISHERS </td>
                                                    <td> UNDER 7 </td>
                                                    <td> 1 LAP RINK </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> AGASTYA NEGI </td>
                                                    <td> I </td>
                                                    <td> KINGFISHERS </td>
                                                    <td> UNDER 7 </td>
                                                    <td> 600m RINK </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 6 </td>
                                                    <td> NANDINI KUKREJA </td>
                                                    <td> II </td>
                                                    <td> DOVES </td>
                                                    <td> UNDER 9 </td>
                                                    <td> 1 LAP RINK </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 7 </td>
                                                    <td> NANDINI KUKREJA </td>
                                                    <td> II </td>
                                                    <td> DOVES </td>
                                                    <td> UNDER 9 </td>
                                                    <td> 2 LAP RINK </td>
                                                    <td> 2nd </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp33.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp33.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp34.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp34.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp35.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp35.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>36th RSFI State Speed Skating Competition</strong></p>
                                    <p><strong>Venue: </strong>Panchkula</p>
                                    <p><strong>Date : </strong>3rd- 6th November2022</p>
                                    <p><strong>Agastya Singh Negi of Grade I Kingfishers was declared as the Haryana Champion in Speed Skating with the highest score in his category.</strong></p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> AGE GROUP </th>
                                                    <th> EVENT </th>
                                                    <th> Position </th>
                                                </tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> UNDER 17 </td>
                                                    <td> 1 LAP RINK </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> AGASTYA NEGI </td>
                                                    <td> I </td>
                                                    <td> KINGFISHERS </td>
                                                    <td> UNDER 7 </td>
                                                    <td> 2 LAP RINK </td>
                                                    <td> 1st </td>
                                                </tr>

                                                <tr>
                                                    <td> 3 </td>
                                                    <td> AGASTYA NEGI </td>
                                                    <td> I </td>
                                                    <td> KINGFISHERS </td>
                                                    <td> UNDER 7 </td>
                                                    <td> 3 LAP RINK </td>
                                                    <td> 1st </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp36.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp36.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp37.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp37.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <p><strong>60th National RSFI Under-7 Skating Championship</strong></p>
                                    <p><strong>Venue: </strong>KRSA, Bangaluru</p>
                                    <p><strong>Date: </strong>10th- 21th December 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> Position </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Agastya Singh Negi </td>
                                                    <td> I </td>
                                                    <td> Kingfishers </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp38.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp38.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>SGFI Haryana State Under-17 Skating Championship</strong></p>
                                    <p><strong>Venue: </strong>Faridabad, Haryana</p>
                                    <p><strong>Date : </strong>23rd - 2th December 2022</p>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp39.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp39.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE/section </th>
                                                    <th> Event </th>
                                                    <th> Position </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX KANCHENJUNGA </td>
                                                    <td> 500 METERS RINK RACE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <p><strong> K.R. Mangalam Inter-School Roller Skating Championship</strong></p>
                                    <p><strong>Venue: </strong>Gurugram</p>
                                    <p><strong>Date : </strong>23rd November 2022</p>
                                    <p><strong>School’s Position</strong>: First</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                    <th> CATEGORY </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP </td>
                                                    <td> HIBISCUS </td>
                                                    <td> QUADS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> TOSHANI </td>
                                                    <td> PREP </td>
                                                    <td> DAFFODILS </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> VEDANT SINGH </td>
                                                    <td> II </td>
                                                    <td> PARROTS </td>
                                                    <td> QUADS </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AARAV GUPTA </td>
                                                    <td> I </td>
                                                    <td> PENGUINS </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> DEMYRA YADAV </td>
                                                    <td> I </td>
                                                    <td> HUMMINGBIRDS </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AKSHARA RAJ </td>
                                                    <td> II </td>
                                                    <td> ROBINS </td>
                                                    <td> QUAD </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AGASTYA SINGH NEGI </td>
                                                    <td> I </td>
                                                    <td> KINGFISHERS </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> NANDINI KUKREJA </td>
                                                    <td> II </td>
                                                    <td> PARROTS </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> HRIDYA YADAV </td>
                                                    <td> IV </td>
                                                    <td> CHINARS </td>
                                                    <td> INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 10.&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> YAGN GUPTA </td>
                                                    <td> VI </td>
                                                    <td> NARMADA </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 11.&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> ASHWIKA GUPTA </td>
                                                    <td> VI </td>
                                                    <td> GODAVARI </td>
                                                    <td> INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 12.&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> PRISHA AHUJA </td>
                                                    <td> VI </td>
                                                    <td> GODAVARI </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 1st </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp40.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp40.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp41.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp41.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>GD Goenka Inter-School Roller Skating Championship 2022-2023</strong></p>
                                    <p><strong>Venue: </strong>GD Goenka Public School, Sec-48, Gurugram</p>
                                    <p><strong>Date : </strong>25th &amp; 26th November 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                    <th> CATEGORY </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP </td>
                                                    <td> HIBISCUS </td>
                                                    <td> QUADS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> TOSHANI </td>
                                                    <td> PREP </td>
                                                    <td> DAFFODILS </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> VEDANT SINGH </td>
                                                    <td> II </td>
                                                    <td> PARROTS </td>
                                                    <td> QUADS </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AARAV GUPTA </td>
                                                    <td> I </td>
                                                    <td> PENGUINS </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> BHUVI SINGHAL </td>
                                                    <td> I </td>
                                                    <td> HUMMINGBIRDS </td>
                                                    <td> PROFFESIONAL INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> ASHWIKA GUPTA </td>
                                                    <td> VI </td>
                                                    <td> GODAVARI </td>
                                                    <td> INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> PRISHA AHUJA </td>
                                                    <td> VI </td>
                                                    <td> GODAVARI </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>


                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp42.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp42.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp43.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp43.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>Vibgyor High Inter-School Roller Skating Championship 2022-2023</strong></p>
                                    <p><strong>Venue: </strong>Vibgyor High School, Gurugram</p>
                                    <p><strong>Date : </strong>19th December 2022</p>
                                    <p><strong>Team’s Position: </strong>Second</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                    <th> CATEGORY </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> SARA NARULA </td>
                                                    <td> PREP </td>
                                                    <td> HIBISCUS </td>
                                                    <td> QUADS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> TOSHANI </td>
                                                    <td> PREP </td>
                                                    <td> DAFFODILS </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> VIVAAN AGGARAWAL </td>
                                                    <td> PREP </td>
                                                    <td> DAFFODILS </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> VEDANT SINGH </td>
                                                    <td> II </td>
                                                    <td> PARROTS </td>
                                                    <td> QUADS </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AARAV GUPTA </td>
                                                    <td> I </td>
                                                    <td> PENGUINS </td>
                                                    <td> RECRETAIONAL INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> DEMYRA YADAV </td>
                                                    <td> I </td>
                                                    <td> HUMMINGBIRDS </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AKSHARA RAJ </td>
                                                    <td> II </td>
                                                    <td> ROBINS </td>
                                                    <td> QUAD </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> HRIDYA YADAV </td>
                                                    <td> IV </td>
                                                    <td> CHINARS </td>
                                                    <td> INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AADVIK KHANDPUR </td>
                                                    <td> I </td>
                                                    <td> PENGUINS </td>
                                                    <td> QUADS </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 10.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> PAVIKA SHARMA </td>
                                                    <td> II </td>
                                                    <td> ROBINS </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 11.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> BHUVI SINGLA </td>
                                                    <td> I </td>
                                                    <td> HUMMINGBIRDS </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr>
                                                    <td> 12.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> ADVAY BALECHA </td>
                                                    <td> II </td>
                                                    <td> ROBINS </td>
                                                    <td> RECREATIONAL INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 13.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> YUVAAN CHAWLA </td>
                                                    <td> IV </td>
                                                    <td> CHINARS </td>
                                                    <td> QUADS </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 14.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> SAIYAM NAGPAL </td>
                                                    <td> IV </td>
                                                    <td> ASPENS </td>
                                                    <td> QUADS </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 15.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> HITARTH GOASWAMI </td>
                                                    <td> II </td>
                                                    <td> PARROTS </td>
                                                    <td> INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 16.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AVNI </td>
                                                    <td> III </td>
                                                    <td> PEACOCKS </td>
                                                    <td> INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 17.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> AARAV GUPTA </td>
                                                    <td> VI </td>
                                                    <td> BRAHMAPUTRA </td>
                                                    <td> INLINE </td>
                                                    <td> 3rd </td>
                                                </tr>
                                                <tr>
                                                    <td> 18.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> NAVYA BHATIA </td>
                                                    <td> VII </td>
                                                    <td> JHELUM </td>
                                                    <td> INLINE </td>
                                                    <td> 2nd </td>
                                                </tr>
                                                <tr>
                                                    <td> 19.&nbsp;&nbsp; &nbsp; </td>
                                                    <td> ADVIKA MISHRA </td>
                                                    <td> VIII </td>
                                                    <td> NILE </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp44.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp44.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp45.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp45.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp46.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp46.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <p><strong>CBSE North Zone II Speed Skating Championship 2022-2023</strong></p>
                                    <p><strong>Venue: </strong>South Point Public School, Sonipat</p>
                                    <p><strong>Date : </strong>29th November – 1st December 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                    <th> CATEGORY </th>
                                                    <th> EVENT </th>
                                                    <th> POSITION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> TVESHA YADAV </td>
                                                    <td> IX </td>
                                                    <td> KANCHENJUNGA </td>
                                                    <td> INLINE </td>
                                                    <td> 300 meters Time Trial Rink Race </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp47.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp47.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp48.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp48.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>

                                    <p><strong>Haryana State Girls Under 14 Roll Ball Championship</strong></p>
                                    <p><strong>Venue: </strong>CS International School, Karnal</p>
                                    <p><strong>Date : </strong>13th&amp; 14th November 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> GRADE / SECTION </th>
                                                    <th> Position </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Anushka Choubey </td>
                                                    <td> VII INDUS </td>
                                                    <td> 1st </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp49.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp49.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp50.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp50.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong>36th Haryana State Roll Ball Championship</strong></p>
                                    <p><strong>Venue: </strong>Gurugram</p>
                                    <p><strong>Date : </strong>15th – 17th November 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO </th>
                                                    <th> NAME </th>
                                                    <th> CLASS </th>
                                                    <th> SECTION </th>
                                                    <th> CATEGORY </th>
                                                    <th> POSITION </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> HITARTH GOSWAMI </td>
                                                    <td> II </td>
                                                    <td> PARROTS </td>
                                                    <td> INLINE </td>
                                                    <td> 1st </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp51.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp51.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <h5>TAEKWON-DO</h5>
                                    <p><strong>33rd DELHI STATE &amp; 17th SUB –JUNIOR TAEKWON-DO ITF CHAMPIONSHIP – 2022</strong></p>
                                    <p><strong>Venue: </strong>Thyagraj Stadium</p>
                                    <p><strong>Date : 2nd November</strong></p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Atharv Sharma </td>
                                                    <td> IV </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Advit Sharma </td>
                                                    <td> IV </td>
                                                    <td> Gold
                                                    </td></tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Aadik Jain </td>
                                                    <td> III </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic"><a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp52.jpg">
                                                <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp52.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                            </a></div>
                                        </div>
                                    </div>
                                    <p><strong> Venue: </strong>Thyagraj Stadium</p>
                                    <p><strong>Date : </strong>4th November 2022</p>
                                    <p><strong>All Five players have qualified for the Nationals</strong></p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO. </th>
                                                    <th> NAME </th>
                                                    <th> CATEGORY (KG) </th>
                                                    <th> GRADE </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1 </td>
                                                    <td> Advik Malik </td>
                                                    <td> 40-45 KG </td>
                                                    <td> VII </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2 </td>
                                                    <td> Sidhansh Garg </td>
                                                    <td> 60-65 KG </td>
                                                    <td> VIII </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3 </td>
                                                    <td> Ishant Gupta </td>
                                                    <td> 50-55 KG </td>
                                                    <td> IX </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 4 </td>
                                                    <td> Rashesh Aggarwal </td>
                                                    <td> 60-65 KG </td>
                                                    <td> VIII </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 5 </td>
                                                    <td> Anahita Malik </td>
                                                    <td> 30-35 KG </td>
                                                    <td> II </td>
                                                    <td> Bronze </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp53.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp53.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <p><strong>17th Sub-Junior State championship </strong></p>

                                    <p><strong>Venue: </strong>Thyagraj Stadium</p>
                                    <p><strong>Date : </strong>5th November, 2022</p>
                                    <p><strong> </strong>Lotus Valley International School, Gurugram won the Third Runner-up trophy in the Championship.</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO.
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1
                                                    </td>
                                                    <td> Jivisha Aggarwal </td>
                                                    <td> Prep </td>
                                                    <td> Daisies </td>
                                                </tr>
                                                <tr>
                                                    <td> 2
                                                    </td>
                                                    <td> Vivaan Choudhary </td>
                                                    <td> Prep </td>
                                                    <td> Daisies </td>
                                                </tr>
                                                <tr>
                                                    <td> 3
                                                    </td><td> Shaurrya Walia
                                                    </td><td> Prep
                                                    </td><td> Hibiscus </td>
                                                </tr>
                                                <tr>
                                                    <td> 4
                                                    </td><td> Daiwik Veer Midha
                                                    </td><td> Prep
                                                    </td><td> Hibiscus </td>
                                                </tr>
                                                <tr>
                                                    <td> 5
                                                    </td><td> Ayaan Bakshi
                                                    </td><td> Prep
                                                    </td><td> Hibiscus </td>
                                                </tr>
                                                <tr>
                                                    <td> 6
                                                    </td><td> Vihaan Bhadouria
                                                    </td><td> Prep
                                                    </td><td> Hibiscus </td>
                                                </tr>
                                                <tr>
                                                    <td> 7
                                                    </td><td> Viaan Kalsotra
                                                    </td><td> Prep
                                                    </td><td> Hibiscus </td>
                                                </tr>
                                                <tr>
                                                    <td> 8
                                                    </td><td> Yavana Thakur
                                                    </td><td> Prep
                                                    </td><td> Daffodils </td>
                                                </tr>
                                                <tr>
                                                    <td> 9
                                                    </td><td> Toshani Yadav
                                                    </td><td> Prep
                                                    </td><td> Daffodils </td>
                                                </tr>
                                                <tr>
                                                    <td> 10
                                                    </td><td> Mihika Rana
                                                    </td><td> Prep
                                                    </td><td> Jasmines </td>
                                                </tr>
                                                <tr>
                                                    <td> 11
                                                    </td><td> Aveer Sethi
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 12
                                                    </td><td> Shaunak Aggarwal
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 13
                                                    </td><td> Ritvik Goel
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 14
                                                    </td><td> Dhruvi Panjwani
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 15
                                                    </td><td> Shivaay Chhabra
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 16
                                                    </td><td> Samayra Kapoor
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 17
                                                    </td><td> Samar Sachdeva
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 18
                                                    </td><td> Vedika Bhalla
                                                    </td><td> Prep
                                                    </td><td> Primroses </td>
                                                </tr>
                                                <tr>
                                                    <td> 19
                                                    </td><td> Ryaan Gupta
                                                    </td><td> I
                                                    </td><td> Falcons </td>
                                                </tr>
                                                <tr>
                                                    <td> 20
                                                    </td><td> Riansh Singh
                                                    </td><td> I
                                                    </td><td> Falcons </td>
                                                </tr>
                                                <tr>
                                                    <td> 21
                                                    </td><td> Rudra Rai
                                                    </td><td> I
                                                    </td><td> Falcons </td>
                                                </tr>
                                                <tr>
                                                    <td> 22
                                                    </td><td> Vyom Shukla
                                                    </td><td> I
                                                    </td><td> Flamingoes </td>
                                                </tr>
                                                <tr>
                                                    <td> 23
                                                    </td><td> Aradhya Gunwal
                                                    </td><td> I
                                                    </td><td> Hummingbirds </td>
                                                </tr>
                                                <tr>
                                                    <td> 24
                                                    </td><td> Raahil Singh
                                                    </td><td> I
                                                    </td><td> Kingfishers </td>
                                                </tr>
                                                <tr>
                                                    <td> 25
                                                    </td><td> Dyaansh Sachani
                                                    </td><td> I
                                                    </td><td> Kingfishers </td>
                                                </tr>
                                                <tr>
                                                    <td> 26
                                                    </td><td> Saanvi Govil
                                                    </td><td> I
                                                    </td><td> Magpies </td>
                                                </tr>
                                                <tr>
                                                    <td> 27
                                                    </td><td> Parthiv
                                                    </td><td> I
                                                    </td><td> Magpies </td>
                                                </tr>
                                                <tr>
                                                    <td> 28
                                                    </td><td> Parinika Sharma
                                                    </td><td> I
                                                    </td><td> Nightingales </td>
                                                </tr>
                                                <tr>
                                                    <td> 29
                                                    </td><td> Miraya Dubey
                                                    </td><td> I
                                                    </td><td> Nightingales </td>
                                                </tr>
                                                <tr>
                                                    <td> 30
                                                    </td><td> Kiaan Karjee
                                                    </td><td> I
                                                    </td><td> Penguins </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp54.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp54.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <h5>SWIMMING</h5>

                                    <p><strong> CBSE NATIONAL SWIMMING CHAMPIONSHIP</strong></p>
                                    <p><strong>Venue: </strong>Genius English Medium School, Rajkot (Gujarat)</p>
                                    <p><strong>Date : </strong>19th – 24th January 2023</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr><th>	S.NO.	</th><th>	NAME 	</th><th>	GRADE 	</th><th>	SECTION	</th><th>	EVENT	</th><th>	         MEDALS	</th></tr>

                                            </thead>
                                            <tbody align="center">

                                                <tr><td>	1	</td><td>	Arjun Singh	</td><td>	IX	</td><td>	Everest	</td><td>	50 M Backstroke	</td><td>	Silver	</td></tr>
                                                <tr><td>	2	</td><td>	Arjun Singh	</td><td>	IX	</td><td>	Everest	</td><td>	50 M Freestyle	</td><td>	Bronze	</td></tr>
                                                <tr><td>	3	</td><td>	Arjun Singh	</td><td>	IX	</td><td>	Everest	</td><td>	100 M Backstroke	</td><td>	Bronze	</td></tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp55.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp55.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp56.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp56.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p><strong>Mount St. Mary’s Interschool Swimming Championship</strong></p>
                                    <p><strong>Venue: </strong>Mount St. Mary’s School, Delhi Cantt.</p>
                                    <p><strong>Date : </strong>25th &amp; 26th August 2022</p>
                                    <p><strong>Arjun Singh was announced as the Best Performer.</strong></p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.no
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> TOTAL MEDALS </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 200 m Ind Medley </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Butterfly </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 50 m Freestyle </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 200 m Ind Medley </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 10.&nbsp; &nbsp;
                                                    </td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 50 m Freestyle </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 11.&nbsp; &nbsp;
                                                    </td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 200 m Ind Medley </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 12.&nbsp; &nbsp;
                                                    </td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 13.&nbsp; &nbsp;
                                                    </td>
                                                    <td> Abir Aggarwal </td>
                                                    <td> XI </td>
                                                    <td> Dalton </td>
                                                    <td> 50 m Butterfly </td>
                                                    <td> 1 Bronze </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp57.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp57.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp58.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp58.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp59.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp59.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp60.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp60.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp61.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp61.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                    <p><strong>21st District Swimming Championship</strong></p>
                                    <p><strong>Venue: </strong>Suncity International School, 37D</p>
                                    <p><strong>Date : </strong>24th &amp; 25th September 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.no
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> TOTAL MEDALS </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">

                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 4 Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 3 Silver &amp; 1 Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 2 Gold &amp; 1 Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Abir Aggarwal </td>
                                                    <td> XI </td>
                                                    <td> Dalton </td>
                                                    <td> 1 Bronze </td>
                                                </tr>

                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp62.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp62.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp63.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp63.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p><strong>39th Sub Junior and 49th Junior Haryana State Swimming Championship</strong></p>
                                    <p><strong>Venue: </strong>Ambala</p>
                                    <p><strong>Date : </strong>15th-18th October 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> TOTAL MEDALS </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 150 m Backstroke </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Backstroke </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 200 m Backstroke </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 200 m Ind Medley </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 6.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 200 m Freestyle </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m backstroke relay </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 10.&nbsp; &nbsp;</td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 100 m Backstrokes </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 11.&nbsp; &nbsp;</td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 200 m Backstrokes </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 12.&nbsp; &nbsp;</td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 13.&nbsp; &nbsp;</td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 1500 m freestyle </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr>
                                                    <td> 14.&nbsp; &nbsp;
                                                    </td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 1500 m Freestyle </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 15.&nbsp; &nbsp;</td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 100 m Butterfly </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 16.&nbsp; &nbsp;</td>
                                                    <td> Amreen Brar </td>
                                                    <td> X </td>
                                                    <td> Whitney </td>
                                                    <td> 50 m Butterfly </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp64.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp64.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp65.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp65.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp66.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp66.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p><strong>48th Junior National Aquatic Championship</strong></p>
                                    <p><strong>Venue: </strong>Biju Patnaik Swimming Pool, Bhubaneshwar</p>
                                    <p><strong>Date : </strong>16th-21st July 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Anahat Brar </td>
                                                    <td> IX </td>
                                                    <td> Vindhyas </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <p><strong>CBSE North Zone II Swimming Championship</strong></p>
                                    <p><strong>Venue: </strong>Govindgarh Mandi, Punjab</p>
                                    <p><strong>Date : </strong>5th –  9th December 2022</p>

                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.No
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> TOTAL MEDALS </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Freestyle </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Backstrokes </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr>
                                                    <td> 4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Arjun Singh </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> 100 m Freestyle </td>
                                                    <td> Silver </td>
                                                </tr>
                                                <tr>
                                                    <td> 5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                                    </td>
                                                    <td> Daisha Kaur </td>
                                                    <td> VI </td>
                                                    <td> Kaveri </td>
                                                    <td> 50 m Backstrokes </td>
                                                    <td> Bronze </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp67.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp67.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp68.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp68.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <h5>TABLE TENNIS</h5>
                                    <p><strong> GD Goenka Sports Fiesta (Inter-School Championship)</strong></p>
                                    <p><strong>Venue: </strong>G D Goenka Public School, Sector 48, Gurugram</p>
                                    <p><strong>Date : </strong>25th – 26th November 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO.
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1
                                                    </td>
                                                    <td> Kiaan Garg </td>
                                                    <td> VI </td>
                                                    <td> Brahmaputra </td>
                                                    <td> Table Tennis </td>
                                                    <td> Bronze </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp69.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp69.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp70.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp70.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <h5>GYMNASTICS</h5>
                                    <p><strong>SGFI Under 11 Boys State Championship</strong></p>
                                    <p><strong>Venue: </strong>War Memorial Stadium, Ambala (Haryana)</p>
                                    <p><strong>Date :</strong>08th-10th December 2022</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO.
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1
                                                    </td>
                                                    <td> Aman Verma </td>
                                                    <td> V </td>
                                                    <td> Cedars </td>
                                                    <td> Gymnastics </td>
                                                    <td> Gold </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp71.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp71.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp72.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp72.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <h5>SHOOTING</h5>
                                    <p><strong>65th National Air Pistol Championship</strong></p>
                                    <p><strong>Venue:</strong> Bhopal (MP)</p>
                                    <p><strong>Date : </strong>20th November - 12th December</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO.
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDAL </th>
                                                </tr>


                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1
                                                    </td>
                                                    <td> Aairiya Jain </td>
                                                    <td> IX </td>
                                                    <td> Everest </td>
                                                    <td> Shooting </td>
                                                    <td> Participation </td>
                                                </tr>


                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp73.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp73.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <p><strong> Open Top Gun Winter cup 2023 </strong></p>
                                    <p><strong>Venue: </strong>Gurugram</p>
                                    <p><strong>Date : </strong>16th &amp; 17th January 2023</p>
                                    <div class="admission-table table">
                                        <table cellpadding="0" cellspacing="0" width="100%" border="1" className="table-view">
                                            <thead>
                                                <tr>
                                                    <th> S.NO.
                                                    </th>
                                                    <th> NAME </th>
                                                    <th> GRADE </th>
                                                    <th> SECTION </th>
                                                    <th> EVENT </th>
                                                    <th> MEDAL </th>
                                                </tr>
                                            </thead>
                                            <tbody align="center">
                                                <tr>
                                                    <td> 1
                                                    </td>
                                                    <td> Samraat Sharma </td>
                                                    <td> IV </td>
                                                    <td> Gulmohars </td>
                                                    <td> Benchrest 10 Meter Pistol, Benchrest 10 Meter Rifle </td>
                                                    <td> Silver, Bronze </td>
                                                </tr>
                                                <tr></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp74.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp74.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                        <div class="col-lg-2 col-sm-6 col-xs-12">
                                            <div class="gallery-pic">
                                                <a data-magnify="gallery" data-src="" onClick={() => setIndex(index)} data-group="a" href="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp75.jpg">
                                                    <LazyLoad> <img className="img-fluid mb-4" src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/sports-achievement2223/sp75.jpg" alt="15th RSFI District Speed Skating Competition" /></LazyLoad>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default AcheivementInSports